function Error() {
  return <>Error page</>;
}

export default Error;
